import moment from 'moment';
import { combineReducers } from 'redux';
import leftSidebarReducer, * as leftSidebarReducerContent from './LeftSidebarContent/reducers';
import * as mapActionConstant from './Map/actions';
import mapReducer, * as mapReducerContent from './Map/reducers';
import popUpDetailsReducer from './PopUpDetailsContent/reducers';
import * as constants from './actions';

const filterType = (state = 'daily', action) => {
  switch (action.type) {
    case constants.CHANGE_FILTER_TYPE:
      return action.payload;
    default:
      return state;
  }
};

const filteringDateRange = (
  state = moment(new Date(), 'YYYY/MM/DD'),
  action
) => {
  switch (action.type) {
    case constants.CHANGE_DATE_RANGE:
      return action.payload;
    default:
      return state;
  }
};

const helpPopUpStatus = (state = false, action) => {
  switch (action.type) {
    case constants.CHANGE_HELP_POPUP_STATE:
      return action.payload;
    default:
      return state;
  }
};

const mapLoadingState = (state = false, action) => {
  switch (action.type) {
    case mapActionConstant.FETCH_DISTRIBUTION_HOUSE_SUMMARY_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_DISTRIBUTION_HOUSES_REQUEST:
    case mapActionConstant.FETCH_HIGH_BALANCE_AGENT_SUMMARY_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_HIGH_BALANCE_AGENTS_REQUEST:
    case mapActionConstant.FETCH_DH_STOCK_BALANCE_LIFTING_SUMMARY_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_DH_STOCK_BALANCE_LIFTINGS_REQUEST:
    case mapActionConstant.FETCH_DH_STOCK_PROGRESS_SUMMARY_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_DH_STOCK_PROGRESS_REQUEST:
    case mapActionConstant.FETCH_DH_STOCK_BALANCE_AGENT_SUMMARY_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_DH_STOCK_BALANCE_AGENT_REQUEST:
    case mapActionConstant.FETCH_ACTIVE_AGENT_SUMMARY_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_ACTIVE_AGENTS_REQUEST:
    case mapActionConstant.FETCH_ACTIVE_AGENT_WITHOUT_DISBURSEMENT_SUMMARY_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_ACTIVE_AGENTS_WITHOUT_DISBURSEMENT_REQUEST:
    case mapActionConstant.FETCH_ACTIVE_AGENT_PARTNER_PAYMENT_SUMMARY_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_ACTIVE_AGENTS_PARTNER_PAYMENT_REQUEST:
    case mapActionConstant.FETCH_AGENT_WITH_TRANSACTION_SUMMARY_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_AGENTS_WITH_TRANSACTION_REQUEST:
    case mapActionConstant.FETCH_LEADING_AGENT_SUMMARY_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_LEADING_AGENTS_REQUEST:
    case mapActionConstant.FETCH_LEADING_AGENT_TPV_SUMMARY_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_LEADING_AGENTS_TPV_REQUEST:
    case mapActionConstant.FETCH_LEADING_AGENT_CATEGORY_SUMMARY_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_LEADING_GOLD_AGENTS_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_LEADING_SILVER_AGENTS_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_LEADING_BRONZE_AGENTS_REQUEST:
    case mapActionConstant.FETCH_MILKING_AGENT_SUMMARY_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_MILKING_AGENTS_REQUEST:
      return true;
    case mapActionConstant.FETCH_DISTRIBUTION_HOUSE_SUMMARY_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_DISTRIBUTION_HOUSES_SUCCESS:
    case mapActionConstant.FETCH_HIGH_BALANCE_AGENT_SUMMARY_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_HIGH_BALANCE_AGENTS_SUCCESS:
    case mapActionConstant.FETCH_DH_STOCK_BALANCE_LIFTING_SUMMARY_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_DH_STOCK_BALANCE_LIFTINGS_SUCCESS:
    case mapActionConstant.FETCH_DH_STOCK_PROGRESS_SUMMARY_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_DH_STOCK_PROGRESS_SUCCESS:
    case mapActionConstant.FETCH_DH_STOCK_BALANCE_AGENT_SUMMARY_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_DH_STOCK_BALANCE_AGENT_SUCCESS:
    case mapActionConstant.FETCH_ACTIVE_AGENT_SUMMARY_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_ACTIVE_AGENTS_SUCCESS:
    case mapActionConstant.FETCH_ACTIVE_AGENT_WITHOUT_DISBURSEMENT_SUMMARY_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_ACTIVE_AGENTS_WITHOUT_DISBURSEMENT_SUCCESS:
    case mapActionConstant.FETCH_ACTIVE_AGENT_PARTNER_PAYMENT_SUMMARY_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_ACTIVE_AGENTS_PARTNER_PAYMENT_SUCCESS:
    case mapActionConstant.FETCH_AGENT_WITH_TRANSACTION_SUMMARY_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_AGENTS_WITH_TRANSACTION_SUCCESS:
    case mapActionConstant.FETCH_LEADING_AGENT_SUMMARY_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_LEADING_AGENTS_SUCCESS:
    case mapActionConstant.FETCH_LEADING_AGENT_TPV_SUMMARY_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_LEADING_AGENTS_TPV_SUCCESS:
    case mapActionConstant.FETCH_LEADING_AGENT_CATEGORY_SUMMARY_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_LEADING_GOLD_AGENTS_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_LEADING_SILVER_AGENTS_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_LEADING_BRONZE_AGENTS_SUCCESS:
    case mapActionConstant.FETCH_MILKING_AGENT_SUMMARY_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_MILKING_AGENTS_SUCCESS:
      return false;
    default:
      return state;
  }
};

const detailsViewLoadingState = (state = false, action) => {
  switch (action.type) {
    case mapActionConstant.FETCH_TERRITORY_DISTRIBUTION_HOUSES_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_HIGH_BALANCE_AGENTS_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_DH_STOCK_BALANCE_LIFTINGS_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_DH_STOCK_PROGRESS_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_DH_STOCK_BALANCE_AGENT_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_ACTIVE_AGENTS_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_ACTIVE_AGENTS_WITHOUT_DISBURSEMENT_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_ACTIVE_AGENTS_PARTNER_PAYMENT_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_AGENTS_WITH_TRANSACTION_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_LEADING_AGENTS_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_LEADING_AGENTS_TPV_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_LEADING_GOLD_AGENTS_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_LEADING_SILVER_AGENTS_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_LEADING_BRONZE_AGENTS_REQUEST:
    case mapActionConstant.FETCH_TERRITORY_MILKING_AGENTS_REQUEST:
      return true;
    case mapActionConstant.FETCH_TERRITORY_DISTRIBUTION_HOUSES_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_HIGH_BALANCE_AGENTS_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_DH_STOCK_BALANCE_LIFTINGS_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_DH_STOCK_PROGRESS_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_DH_STOCK_BALANCE_AGENT_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_ACTIVE_AGENTS_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_ACTIVE_AGENTS_WITHOUT_DISBURSEMENT_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_ACTIVE_AGENTS_PARTNER_PAYMENT_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_AGENTS_WITH_TRANSACTION_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_LEADING_AGENTS_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_LEADING_AGENTS_TPV_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_LEADING_GOLD_AGENTS_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_LEADING_SILVER_AGENTS_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_LEADING_BRONZE_AGENTS_SUCCESS:
    case mapActionConstant.FETCH_TERRITORY_MILKING_AGENTS_SUCCESS:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  leftSidebar: leftSidebarReducer,
  map: mapReducer,
  mapLoadingState,
  filterType,
  filteringDateRange,
  popUpDetails: popUpDetailsReducer,
  helpPopUpStatus: helpPopUpStatus,
  detailsViewLoadingState
});

export const COUNTRY = leftSidebarReducerContent.COUNTRY;
export const REGION = leftSidebarReducerContent.REGION;
export const AREA = leftSidebarReducerContent.AREA;
export const TERRITORY = leftSidebarReducerContent.TERRITORY;

export const getSndCountryDetails = state =>
  leftSidebarReducerContent.getSndCountryDetails(state);

export const getSndRegionDetails = state =>
  leftSidebarReducerContent.getSndRegionDetails(state);

export const getSndAreaDetails = state =>
  leftSidebarReducerContent.getSndAreaDetails(state);

export const getSndTerritoryDetails = state =>
  leftSidebarReducerContent.getSndTerritoryDetails(state);

export const getSelectedState = state =>
  leftSidebarReducerContent.getSelectedState(state);

export const getFilteringState = state =>
  leftSidebarReducerContent.getFilteringState(state);

export const getMapLoadingState = state => {
  return state.user.snd.mapLoadingState;
};

export const getDetailsViewLoadingState = state => {
  return state.user.snd.detailsViewLoadingState;
};

export const getFilterType = state => {
  return state.user.snd.filterType;
};

export const getFilteringDateRange = state => {
  return state.user.snd.filteringDateRange;
};

export const getHelpPopUpStatus = state => {
  return state.user.snd.helpPopUpStatus;
};

export const getActiveDistributionHouses = state =>
  mapReducerContent.getActiveDistributionHouses(state);

export const getHighBalanceAgents = state =>
  mapReducerContent.getHighBalanceAgents(state);

export const getDhStockBalanceLiftings = state =>
  mapReducerContent.getDhStockBalanceLiftings(state);

export const getDhStockProgress = state =>
  mapReducerContent.getDhStockProgress(state);

export const getDhStockBalanceAgents = state =>
  mapReducerContent.getDhStockBalanceAgents(state);

export const getActiveAgents = state =>
  mapReducerContent.getActiveAgents(state);

export const getActiveAgentsWithoutDisbursement = state =>
  mapReducerContent.getActiveAgentsWithoutDisbursement(state);

export const getActiveAgentsPartnerPayment = state =>
  mapReducerContent.getActiveAgentsPartnerPayment(state);

export const getAgentsWithTransaction = state =>
  mapReducerContent.getAgentsWithTransaction(state);

export const getLeadingAgents = state =>
  mapReducerContent.getLeadingAgents(state);

export const getLeadingAgentsTpv = state =>
  mapReducerContent.getLeadingAgentsTpv(state);

export const getLeadingGoldAgents = state =>
  mapReducerContent.getLeadingGoldAgents(state);

export const getLeadingSilverAgents = state =>
  mapReducerContent.getLeadingSilverAgents(state);

export const getLeadingBronzeAgents = state =>
  mapReducerContent.getLeadingBronzeAgents(state);

export const getMilkingAgents = state =>
  mapReducerContent.getMilkingAgents(state);
